import { render, staticRenderFns } from "./ModalRestoreUser.vue?vue&type=template&id=30f0d6e7"
import script from "./ModalRestoreUser.vue?vue&type=script&lang=js"
export * from "./ModalRestoreUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports